import ConfirmActionButton from './presentation';

export default ConfirmActionButton;
